import React from 'react'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import ResourceFieldsCollection from 'modules/custom_resources/store/collections/customFields/resourceFields'
import { ChoiceOption } from 'modules/custom_resources/store/models/customFields/Field'

export interface IFields {
  label: string
  value: number
  field_type: string
  choice_options: ChoiceOption[]
}

export const useCustomFieldsOptions = (usageGroup: string[]) => {
  const currentCompanyId = useCurrentSession().company.id
  const [customFields, setCustomFields] = React.useState<IFields[]>([])

  const resourceFieldCollection = useLazyRef(
    () =>
      new ResourceFieldsCollection([], {
        model_ref: 'company',
        instance_id: currentCompanyId,
      })
  ).current

  const { loading } = useAsyncData(() => {
    resourceFieldCollection.config = {
      model_ref: 'company',
      instance_id: currentCompanyId,
    }

    return Promise.all([resourceFieldCollection.byUsageGroup(usageGroup)])
  }, [])

  useEffect(() => {
    if (loading) return

    const fields = resourceFieldCollection.map((field) => {
      return {
        label: field.attributes.label,
        value: field.id,
        field_type: field.attributes.field_type,
        choice_options: field.attributes.choice_options,
      }
    })
    setCustomFields(fields)
  }, [loading]) // eslint-disable-line react-hooks/exhaustive-deps

  return {
    loading,
    customFields,
  }
}
